$(window).on('load scroll', function() {
    const scroll = $(window).scrollTop();

    if (scroll >= 3) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
});

$(document).ready(function() {
    var svgText = $('.site-header__logo .text-path');

    setTimeout(function() {
        $(svgText).addClass('transparency');
    }, 1000);
});
